export enum EndpointTags {
    CONFIRMED_DEAL = "ConfirmedDeal",
    GET_CURRENT_DEAL = "getCurrentDeal",
    // Task tags
    UPDATE_TASK = "updateTask",
    GET_TASK_BY_ID = "getTaskById",
    GET_TASKS = "getTasks",
}

export enum EmpresaEndpointTags {
    GET_EMPRESAS = "getEmpesas",
}

export enum VendedorEndpointTags {
    GET_EQUIPOS_VENTAS = "getEquiposVentas",
    GET_VENDEDOR_BY_ID = "getVendedorById",
}

export enum VisitasEndpointTags {
    GET_VISITA_BY_ID = "getVisitaById",
}

export enum DealsEndpointTags {
    GET_DEAL_INFO_BY_ID = "getDealInformationById",
}

export enum PipelineEndpointTags {
    GET_PIPELINE_INFO ="getPipelineInfo",
}

export enum TaskEndpointTags {
    GET_TASKS = "getTasks",
    GET_TASK_BY_ID = "getTaskById",
}